// extracted by mini-css-extract-plugin
export var heroWrapper = "hero-module--heroWrapper--k8SrJ";
export var heroWrapperWithMargin = "hero-module--heroWrapperWithMargin--z7nK2";
export var image = "hero-module--image--fYdDF";
export var title = "hero-module--title--6QmM5";